import { render } from "./Main.vue?vue&type=template&id=34ae4f46"
const script = {}
script.render = render

export default script